import Observer from './../util/observer'
import authentication from './authentication'

export default (store) => {
  const observer = new Observer(store)
  authentication(observer, store)
}
